import { render, staticRenderFns } from "./senarai-pindaan.vue?vue&type=template&id=4e802644&"
import script from "./senarai-pindaan.vue?vue&type=script&lang=js&"
export * from "./senarai-pindaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports